module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_7005.89cf4a78.png";